import React from "react";
import aetna from "../../assets/screener/insurance-aetna.png";
import blueCrossBlueShield from "../../assets/screener/insurance-bcbs.png";
import cigna from "../../assets/screener/insurance-cigna.png";
import optum from "../../assets/screener/insurance-optum.png";
import unitedHealthcare from "../../assets/screener/insurance-united-healthcare.png";

type Insurance = {
  readonly name: string;
  readonly logo: string;
};

const TX_INSURANCES: readonly Insurance[] = [
  { name: "Aetna", logo: aetna },
  { name: "Blue Cross Blue Shield", logo: blueCrossBlueShield },
  { name: "Cigna", logo: cigna },
  { name: "Optum", logo: optum },
  { name: "United Healthcare", logo: unitedHealthcare }
];

export default function InsuranceLogos() {
  return (
    <ul className="screener-insurances" aria-label="Active Texas insurances">
      {TX_INSURANCES.map(insurance => (
        <li key={insurance.name} className="screener-insurance">
          <img className="screener-insurance__logo" src={insurance.logo} alt={insurance.name} />
        </li>
      ))}
    </ul>
  );
}
